"use strict";

const initializeMinicart = () => {
    const $minicartContainer   = $(".js-minicart");
    const cartEmptyRedirectUrl = $minicartContainer.data("empty-cart-url");
    const isOnPlanChangeFlow   = $minicartContainer.data("on-change-plan-flow");

    if (isOnPlanChangeFlow) {
        $(document).on("click", ".js-minicart", (e) => {
            e.preventDefault();

            const $planConflictModal   = $(".js-plan-conflict-modal");

            $planConflictModal.find(".js-plan-conflict-submit").attr("is-add-product", false);
            $planConflictModal.toggleClass("show", true);
        });
    }

    $(document).on("click", ".js-plan-conflict-submit[is-add-product='false']", function () {
        window.location.href = cartEmptyRedirectUrl;
    });

    $(document).on("click", ".js-plan-conflict-close", function () {
        const $planConflictModal = $(".js-plan-conflict-modal");

        $planConflictModal.toggleClass("show", false);
    });

};

export default initializeMinicart;
